import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl, _getEprocessUrl} from './Handler.js'
import store from '../store/index'

export function _getAll(){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/projects/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _getAllProjectCombo(){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/projects/all`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _create(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/projects`;
    return axios.post(url,model,config).then(_handleSuccess,_handleError)
}
export function _update(model){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/projects`;
    return axios.put(url,model,config).then(_handleSuccess,_handleError)
}
export function _getById(id){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/projects/${id}`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _requestGibUser(params){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' }, params :params };
    const url = `${_getEprocessUrl()}eProcesses/gibUser`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _getDocument(params){
  
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' }, params :params };
    const url = `${_getEprocessUrl()}eProcesses/document`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _getDocumentStatus(params){
  
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' }, params :params };
    const url = `${_getEprocessUrl()}eProcesses`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}